import React from 'react';
import {Switch} from 'react-router-dom';
import {useIntl} from 'react-intl';

import PrivateRoute from '../../components/PrivateRoute';
import withLayout from '../../components/ui/Layout';
import StateList from './StateList';
import StateDetail from './StateDetail';
import CreateState from './CreateState';
import EditState from './EditState';

function States() {
    const intl = useIntl();

    return (
        <Switch data-test='statesComponent'>
            <PrivateRoute
                permission='STATES_INDEX'
                exact
                path='/states'
                component={withLayout(
                    StateList,
                    intl.formatMessage({id: 'ROUTES.STATES.INDEX'}),
                )}
            />

            <PrivateRoute
                permission='STATES_CREATE'
                exact
                path='/states/create'
                component={withLayout(
                    CreateState,
                    intl.formatMessage({id: 'ROUTES.STATES.CREATE'}),
                )}
            />

            <PrivateRoute
                permission='STATES_EDIT'
                exact
                path='/states/:id/edit'
                component={withLayout(
                    EditState,
                    intl.formatMessage({id: 'ROUTES.STATES.EDIT'}),
                )}
            />

            <PrivateRoute
                permission='STATES_SHOW'
                exact
                path='/states/:id'
                component={withLayout(
                    StateDetail,
                    intl.formatMessage({id: 'ROUTES.STATES.SHOW'}),
                )}
            />
        </Switch>
    );
}

export default States;
